import { useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'sonner';
import { ChevronRight } from 'lucide-react';
import api from '../../lib/api';
import ScanOrType from './ScanOrType';
import ToolHeader, { NoAccess, Spinner } from './ToolHeader';

export default function ProductsTool() {
  const { tools } = useOutletContext();
  const navigate = useNavigate();
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);

  const lookup = async (code) => {
    setLoading(true);
    try {
      const { data } = await api.get('/staff-app/products/lookup', { params: { q: code } });
      if (data.exact && data.products.length === 1) return navigate(data.products[0].product_id);
      setResults(data.products);
      if (!data.products.length) toast.error(`No product found for "${code}"`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Lookup failed');
    } finally { setLoading(false); }
  };

  if (tools && !tools.products_view) return <><ToolHeader title="Products" /><NoAccess /></>;
  return (
    <div data-testid="staff-app-products-tool">
      <ToolHeader title="Products" subtitle={tools?.products_edit ? 'Scan or search to edit' : 'View only'} />
      <div className="p-4 space-y-3">
        <ScanOrType onCode={lookup} testId="staff-app-products-scan" />
        {loading ? <Spinner /> : results && (
          <div className="divide-y divide-border rounded-xl border border-border bg-card" data-testid="staff-app-products-results">
            {results.map((p) => (
              <button key={p.product_id} onClick={() => navigate(p.product_id)} data-testid={`staff-app-product-${p.product_id}`}
                className="w-full flex items-center gap-3 px-3.5 py-3 text-left hover:bg-muted/50">
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-semibold truncate">{p.name}</span>
                  <span className="block text-xs text-muted-foreground truncate">{p.manufacturer || 'No manufacturer'} · {p.stock_quantity ?? 0} in stock{p.barcode ? ` · ${p.barcode}` : ''}</span>
                </span>
                <ChevronRight className="w-4 h-4 text-muted-foreground" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
